/** 
 * @type {import("./defs").StoreTransaction} 
 */ 
 const store = { 
 } 
 /** 
 * @returns {import("./defs").StoreTransaction} 
 */ 
 export default function () { 
 return JSON.parse(JSON.stringify(store)); 
 }


// WEBPACK FOOTER //
// ./resources/js/storers/StoreTransaction.js